import { Editor } from '@tiptap/react';
import { BubbleMenu } from '@tiptap/react/menus';
import { Bold, Italic, Underline as UnderlineIcon, Link, Type } from 'lucide-react';

interface FloatingToolbarProps {
    editor: Editor | null;
}

export function FloatingToolbar({ editor }: FloatingToolbarProps) {
    if (!editor) return null;

    return (
        <BubbleMenu
            editor={editor}
            {...({ tippyOptions: { duration: 150 } } as any)}
            className="flex items-center gap-1 p-1 bg-white dark:bg-zinc-900 border border-zinc-200 dark:border-zinc-800 rounded-lg shadow-xl overflow-hidden backdrop-blur-md bg-opacity-90 dark:bg-opacity-90"
        >
            <button
                onClick={() => editor.chain().focus().toggleBold().run()}
                className={`p-2 hover:bg-zinc-100 dark:hover:bg-zinc-800 rounded transition-colors ${editor.isActive('bold') ? 'text-sage font-bold' : 'text-zinc-600 dark:text-zinc-400'}`}
                title="Bold (⌘B)"
            >
                <Bold size={16} />
            </button>
            <button
                onClick={() => editor.chain().focus().toggleItalic().run()}
                className={`p-2 hover:bg-zinc-100 dark:hover:bg-zinc-800 rounded transition-colors ${editor.isActive('italic') ? 'text-sage italic' : 'text-zinc-600 dark:text-zinc-400'}`}
                title="Italic (⌘I)"
            >
                <Italic size={16} />
            </button>
            <button
                onClick={() => editor.chain().focus().toggleUnderline().run()}
                className={`p-2 hover:bg-zinc-100 dark:hover:bg-zinc-800 rounded transition-colors ${editor.isActive('underline') ? 'text-sage underline' : 'text-zinc-600 dark:text-zinc-400'}`}
                title="Underline (⌘U)"
            >
                <UnderlineIcon size={16} />
            </button>

            <div className="w-px h-4 bg-zinc-200 dark:bg-zinc-800 mx-1" />

            <button
                onClick={() => {
                    const url = window.prompt('Enter URL');
                    if (url) editor.chain().focus().setLink({ href: url }).run();
                }}
                className={`p-2 hover:bg-zinc-100 dark:hover:bg-zinc-800 rounded transition-colors ${editor.isActive('link') ? 'text-sage' : 'text-zinc-600 dark:text-zinc-400'}`}
                title="Link"
            >
                <Link size={16} />
            </button>

            <button
                onClick={() => editor.chain().focus().toggleHeading({ level: 3 }).run()}
                className={`p-2 hover:bg-zinc-100 dark:hover:bg-zinc-800 rounded transition-colors ${editor.isActive('heading', { level: 3 }) ? 'text-sage font-bold' : 'text-zinc-600 dark:text-zinc-400'}`}
                title="Heading"
            >
                <Type size={16} />
            </button>
        </BubbleMenu>
    );
}
